import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CsrfService } from '../auth/csrf.service';

const MUTATING_METHODS = ['POST', 'PUT', 'DELETE', 'PATCH'];

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  private csrfService = inject(CsrfService);


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!MUTATING_METHODS.includes(req.method.toUpperCase())) {
      return next.handle(req);
    }

    const csrfToken = this.csrfService.getCsrfToken();
    if (csrfToken) {
      const cloned = req.clone({
        setHeaders: { 'X-CSRF-Token': csrfToken },
      });
      return next.handle(cloned);
    }

    return next.handle(req);
  }
}
